module.exports = __webpack_public_path__ + "static/domain-whois_5-529981de05ec7d2a73c42042816b490c.jpg";